export default "__VITE_ASSET__6zVrZN4m__"